const INTVS = [
   {
      "id": "intv-open-airway-method-head-tilt",
      "system": "airway",
      "label": "Head tilt chin lift"
   },
   {
      "id": "intv-open-airway-method-modified-jaw-thrust",
      "system": "airway",
      "label": "Modified jaw thrust"
   },
   {
      "id": "intv-airway-patency-technique-suction-airway",
      "system": "airway",
      "label": "Suction airway",
      "prompts": [
         "prompt-airway-patency-suction-device"
      ]
   },
   {
      "id": "intv-manual-finger-sweep",
      "system": "airway",
      "label": "Manual (finger sweep)"
   },
   {
      "id": "intv-magill-forceps-assisted",
      "system": "airway",
      "label": "Magill forceps assisted"
   },
   {
      "id": "intv-slat",
      "system": "airway",
      "label": "SLAT"
   },
   {
      "id": "intv-heimlich-maneuver",
      "system": "airway",
      "label": "Heimlich maneuver"
   },
   {
      "id": "intv-back-blows-and-chest-thrusts",
      "system": "airway",
      "label": "Back blows and chest thrusts"
   },
   {
      "id": "intv-oropharyngeal-airway",
      "system": "airway",
      "label": "Oropharyngeal airway (OPA)"
   },
   {
      "id": "intv-nasopharyngeal-airway",
      "system": "airway",
      "label": "Nasopharyngeal airway (NPA)"
   },
   {
      "id": "intv-advanced-airway-adjunct",
      "system": "airway",
      "label": "Insert advanced airway adjunct",
      "prompts": [
         "prompt-advanced-airway-adjunct-type",
         "prompt-advanced-airway-tube-size"
      ]
   },
   {
      "id": "intv-orotracheal-intubation",
      "system": "airway",
      "label": "Orotracheal intubation",
      "prompts": [
         "prompt-orotracheal-intubation-tube-insertion-depth"
      ]
   },
   {
      "id": "intv-nasotracheal-intubation",
      "system": "airway",
      "label": "Nasotracheal intubation",
      "prompts": [
         "prompt-nasotracheal-intubation-tube-size"
      ]
   },
   {
      "id": "intv-rapid-sequence-intubation",
      "system": "airway",
      "label": "Rapid sequence intubation (RSI)"
   },
   {
      "id": "intv-sedation-assisted-intubation",
      "system": "airway",
      "label": "Sedation-assisted intubation",
      "prompts": []
   },
   {
      "id": "intv-needle-cricothyrotomy",
      "system": "airway",
      "label": "Needle cricothyrotomy"
   },
   {
      "id": "intv-surgical-cricothyrotomy",
      "system": "airway",
      "label": "Surgical cricothyrotomy"
   },
   {
      "id": "intv-supplemental-oxygen-device-nasal-cannula",
      "system": "breathing",
      "label": "Nasal cannula",
      "prompts": [
         "prompt-nasal-cannula-o2-flow-rate",
         "prompt-nasal-cannula-target-saturation"
      ]
   },
   {
      "id": "intv-supplemental-oxygen-device-non-rebreather-mask",
      "system": "breathing",
      "label": "Non-rebreather mask",
      "prompts": [
         "prompt-non-rebreather-mask-flow-rate",
         "prompt-non-rebreather-mask-target-saturation"
      ]
   },
   {
      "id": "intv-ventilation-technique-bag-valve-mask",
      "system": "breathing",
      "label": "Bag-valve mask",
      "prompts": [
         "prompt-bvm-ventilation-rate",
         "prompt-bvm-flow-rate",
         "prompt-bvm-target-saturation"
      ]
   },
   {
      "id": "intv-control-severe-bleeding-technique-direct-pressure",
      "system": "bleeding",
      "label": "Apply direct pressure",
      distPrompts: [
         "prompt-wound-location"
      ]
   },
   {
      "id": "intv-control-severe-bleeding-technique-tourniquet",
      "system": "bleeding",
      "label": "Apply tourniquet",
      distPrompts: [
         "prompt-wound-location"
      ],
      prompts: [
         "prompt-tourniquet-placement"
      ]
   },
   {
      "id": "intv-control-severe-bleeding-technique-2nd-tourniquet",
      "system": "bleeding",
      "label": "Apply second tourniquet",
      distPrompts: [
         "prompt-wound-location"
      ],
      prompts: [
         "prompt-2nd-tourniquet-placement"
      ]
   },
   {
      "id": "intv-control-severe-bleeding-technique-pack-wound-with-gauze",
      "system": "bleeding",
      "label": "Pack wound with gauze or hemostatic gauze",
      distPrompts: [
         "prompt-wound-location"
      ],
   },
   {
      "id": "intv-control-severe-bleeding-technique-pressure-bandage",
      "system": "bleeding",
      "label": "Pressure dressing",
      distPrompts: [
         "prompt-wound-location"
      ],
   },
   {
      "id": "intv-control-severe-bleeding-technique-load-and-go",
      "system": "bleeding",
      "label": "Load and go (if uncontrolled)"
   },
   {
      "id": "intv-control-shock-technique-keep-patient-warm",
      "system": "shock",
      "label": "Keep patient warm (e.g., apply blankets)"
   },
   {
      "id": "intv-control-shock-technique-administer-high-concentration-o2",
      "system": "shock",
      "label": "Administer high concentration of oxygen"
   },
   {
      "id": "intv-control-shock-technique-place-patient-supine-position",
      "system": "shock",
      "label": "Place or maintain patient in supine position"
   },
   {
      "id": "intv-control-shock-technique-administer-iv-boluses",
      "system": "shock",
      "label": "IV fluid resuscitation",
      prompts: []
   },
   {
      "id": "intv-occlusive-dressing",
      "system": "breathing",
      "label": "Occlusive dressing",
      prompts: [
         "prompt-occlusive-dressing-injury-type",
         "prompt-occlusive-dressing-method",
      ]
   },
   {
      "id": "intv-pleural-decompression",
      "system": "breathing",
      "label": "Needle decompression",
      prompts: [
         "prompt-pleural-decompression-injury-type",
         "prompt-pleural-decompression-needle-placement-side-of-the-body",
         "prompt-pleural-decompression-needle-placement-anatomical-landmark",
         "prompt-pleural-decompression-needle-size",
         "prompt-pleural-decompression-needle-length"
      ]
   },
   {
      "id": "intv-spinal-immobilization-technique-manual-c-spine",
      "label": "Manual c-spine stabilization"
   },
   {
      "id": "intv-spinal-immobilization-technique-cervical-collar",
      "label": "Cervical collar"
   },
   {
      "id": "intv-spinal-immobilization-technique-transfer-to-device",
      "label": "Transfer patient to immobilization device",
      prompts: [

      ]
   },
   {
      "id": "intv-spinal-immobilization-technique-attach-cid",
      "label": "Attach cervical immobilization device (CID)"
   },

   {
      "id": "intv-transfers-patient-method-walk-patient",
      "label": "Walk patient to ambulance"
   },
   {
      "id": "intv-transfers-patient-method-place-directly-on-stretcher",
      "label": "Place directly on stretcher"
   },
   {
      id: "intv-place-immobilized-patient-on-stretcher",
      label: "Place immobilized patient on stretcher"
   },
   /*
   {
      "id": "intv-transfers-patient-method-long-backboard",
      "label": "Place on long back board (LBB)"
   },
   {
      "id": "intv-transfers-patient-method-short-board",
      "label": "Place on short board (e.g., KED)"
   },
   {
      "id": "intv-transfers-patient-method-scoop-stretcher",
      "label": "Place on scoop stretcher"
   },
   */
   {
      "id": "intv-transport",
      "label": "Transport",
      prompts: [
         "prompt-transport-facility-choice",
         "prompt-transport-method",
         "prompt-transport-lights-siren-decision"
      ]
   },
   {
      "id": "intv-apply-sterile-dressings",
      "label": "Apply sterile dressings",
      distPrompts: [
         "prompt-wound-locations"
      ],
   },
   {
      "id": "intv-splint-fractures",
      "system": "bleeding",
      "label": "Splint fractures",
      // distPrompts: [
      // ],
      // prompts: [
      //    "prompt-splint-type"
      // ]
   },

   {
      id: "intv-sterile-dressing-soft-tissue",
      label: "Apply sterile dressing over soft tissue",
      distPrompts: [
         "prompt-wound-location"
      ],
   },
   {
      "id": "intv-retrieve-amputated-body-part",
      "label": "Retrieve avulsed/amputated part",
      distPrompts: [
         "prompt-wound-location"
      ],
   },
   {
      id: "intv-wrap-body-part-in-saline-soaked-gauze",
      label: "Wrap part in gauze soaked in saline",
      distPrompts: [
         "prompt-wound-location"
      ],
   },
   {
      id: "intv-place-body-part-in-bag",
      label: "Place part in bag",
      distPrompts: [
         "prompt-wound-location"
      ],
   },
   {
      id: "intv-keep-body-part-cool",
      label: "Keep cool but do not pack directly on ice",
      distPrompts: [
         "prompt-wound-location"
      ],
   },
   {
      id: "intv-transport-body-part-to-receiving-facility",
      label: "Transport part to receiving facility",
      distPrompts: [
         "prompt-wound-location"
      ],
   },
   // {
   //    "id": "intv-establish-ivs",
   //    "label": "Establish IVs"
   // },
   // {
   //    "id": "intv-replace-bls-airway-with-als-airway",
   //    "label": "Replace basic airway with advanced airway"
   // },
   // {
   //    "id": "intv-replace-bandages",
   //    "label": "Replace bandages"
   // },
   // {
   //    "id": "intv-replace-oxygen-tank",
   //    "label": "Replace oxygen tank"
   // },
   // {
   //    "id": "intv-adjust-iv-replace-bolus",
   //    "label": "Adjust an IV (e.g., hang second bag)"
   // },
   // {
   //    "id": "intv-turn-up-heat-in-ambulance",
   //    "label": "Turn up heat in ambulance"
   // },
   // {
   //    "id": "intv-reassess-intv-other",
   //    "label": "Reassess other intervention"
   // },
   // {
   //    "id": "intv-reassess-vital-signs",
   //    "label": "Reassess vital signs"
   // }
   {
      id: "intv-prepare-and-administer-pain-nausea-vomiting-medications",
      label: "Prepare and administer medications"
   },
   {
      id: "intv-prepare-and-administer-sedative",
      label: "Prepare and administer medications"
   },
]

export default INTVS